import React from 'react';
import style from './index.module.css';
import MyFooter from '../../components/MyFooter';
import { getImage } from '../../utils/utils';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { faqList } from '../../assets/constants';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';

const WhyUs = () => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';

	const sectionVariants = {
		initial: { opacity: 0, y: 50 },
		whileInView: { opacity: 1, y: 0 },
		transition: { duration: 0.8 }
	};

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			style={{
				width: '100%',
				minHeight: '100vh',
				backgroundColor: theme.palette.background.default,
				color: theme.palette.text.primary,
			}}
		>
			<div className={style.container}>
				<motion.section 
					variants={sectionVariants}
					initial="initial"
					whileInView="whileInView"
					viewport={{ once: true }}
					className={style.section}
				>
					<div className={style.content}>
						<h1 className={style.title} style={{ color: theme.palette.primary.main }}>Who We Are</h1>
						<h2 className={style.subTitle}>Smart, Creative and Attractive</h2>
						<p className={style.paragraph}>
							Shri Hari Tent House constantly provides good quality service to customers, keeping up with the latest market trends.
						</p>
						<p className={style.paragraph}>
							We are providers of Shamiyana's, Furniture, and Cooking vessels for weddings and functions. 
							Our team of qualified and experienced professionals ensures unmatched quality at industry-leading prices.
						</p>
					</div>
					<motion.div whileHover={{ scale: 1.05, rotate: 2 }} className={style.imageWrapper}>
						<img
							className={style.image}
							src={getImage('image31')}
							alt='Our team at work'
						/>
					</motion.div>
				</motion.section>

				<motion.section 
					variants={sectionVariants}
					initial="initial"
					whileInView="whileInView"
					viewport={{ once: true }}
					className={`${style.section} ${style.reverse}`}
				>
					<div className={style.content}>
						<h1 className={style.title} style={{ color: theme.palette.primary.main }}>What We Work</h1>
						<h2 className={style.subTitle}>We Enhance Your Celebration</h2>
						<p className={style.paragraph}>
							With just one phone call, our expert team will visit your site and explain everything, handling all the details for you.
						</p>
						<p className={style.paragraph}>
							We analyze the budget and requirements of our clients to meet their expectations perfectly. 
							Our sophisticated warehouse maintains quality standards, keeping us ahead of time.
						</p>
					</div>
					<motion.div whileHover={{ scale: 1.05, rotate: -2 }} className={style.imageWrapper}>
						<img
							className={style.image}
							src={getImage('image32')}
							alt='Exhibition stalls and decor'
						/>
					</motion.div>
				</motion.section>

				<motion.section 
					initial={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					viewport={{ once: true }}
					className={style.faqSection}
				>
					<div className={style.sectionHeader}>
						<p style={{ color: theme.palette.primary.main }}>QUESTIONS?</p>
						<h1>Common Inquiries</h1>
					</div>
					<div className={style.faqList}>
						{faqList.map((item, index) => (
							<Accordion 
								key={index}
								sx={{
									backgroundColor: isDark ? 'rgba(255,255,255,0.03)' : '#fff',
									mb: 2,
									borderRadius: '1rem !important',
									'&:before': { display: 'none' },
									boxShadow: isDark ? '0 10px 30px rgba(0,0,0,0.3)' : '0 10px 30px rgba(0,0,0,0.05)',
								}}
							>
								<AccordionSummary expandIcon={<ExpandMoreIcon color="primary" />}>
									<Typography sx={{ fontWeight: 700, fontSize: '1.1rem' }}>{item.question}</Typography>
								</AccordionSummary>
								<AccordionDetails sx={{ py: 3, px: 2, backgroundColor: isDark ? 'rgba(0,0,0,0.1)' : 'rgba(0,0,0,0.02)' }}>
									<Typography sx={{ opacity: 0.8, lineHeight: 1.8 }}>{item.answer}</Typography>
								</AccordionDetails>
							</Accordion>
						))}
					</div>
				</motion.section>
			</div>

			{/* Footer Section */}
			<MyFooter />
		</motion.div>
	);
};

export default WhyUs;
